import React, { useCallback, ReactElement } from 'react';
import TableRow from '../../../../components/table-row/table-row.component';
import TableCell from '../../../../components/table-cell/table-cell.component';
import CheckAccess from '../../../../components/check-access/check-access.component';
import ActionButton from '../../../../components/action-button/action-button.component';
import DealTermRowForm from '../deal-term-row-form/deal-term-row-form.component';
import MoreIcon from '../../../../icons/more-icon';
import { DATA_DEAL_TERM_ID } from '../../../../constants/system/data-attributes';

const DealTermRow: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isNewDeal,
    isEditMode,
    inputRefs,
    actionMenuItems,
    dealTermIndex,
    dealTermItem,
    dealTermGroup,
    onDeleteClick,
    onOpenActionMenu,
  } = props;

  const onActionCellClick: MouseEventHandlerFunction = useCallback((
    event: React.MouseEvent<Element, MouseEvent>,
  ): void => {
    event.stopPropagation();
  }, []);

  return (
    isEditMode || isNewDeal ? (
      <DealTermRowForm
        dealTermIndex={dealTermIndex}
        dealTermGroupData={dealTermGroup}
        dealTermData={dealTermItem}
        inputRefs={inputRefs}
        onDeleteClick={(): void => {
          onDeleteClick(dealTermItem.id, dealTermGroup.id);
        }}
      />
    ) : (
      <TableRow>
        <TableCell isHeader>
          {dealTermItem.name}
        </TableCell>
        <TableCell isTextMultiline>
          {dealTermItem.content}
        </TableCell>
        <TableCell isTextRight width="5%" onClick={onActionCellClick}>
          <CheckAccess
            permissions={actionMenuItems
              && actionMenuItems.map((actionMenuItem: ActionMenuItem): string | undefined => (
                actionMenuItem.permission
              ))}
          >
            <ActionButton
              withPopup
              withSmallPadding
              onClick={onOpenActionMenu}
              {...{
                [DATA_DEAL_TERM_ID]: dealTermItem.id,
              }}
            >
              <MoreIcon />
            </ActionButton>
          </CheckAccess>
        </TableCell>
      </TableRow>
    )
  );
});

export default DealTermRow;
